import * as z from 'zod';

import { nullableNumericMutationSchema } from '@/_schemas/generic';

import { commissionPeriodsMutationSchema } from './commission-periods-schema';
import { teamMemberQuerySchema } from './team-members-query-schema';

export const teamMemberUpdateSchema = teamMemberQuerySchema
  .omit({
    status: true,
    phone_numbers: true,
    profile_image: true,
    preferred_relationship: true,
    emergency_contact: true,
    addresses: true,
    gallery: true,
    offer_letter: true,
    employment_agreement: true,
    handbook_acknowledgement: true,
    vector_signatured: true,
    business_card_template: true,
  })
  .extend({
    status: z.string(),
    phone_numbers: z.array(z.number()),
    profile_image: z.array(z.number()),
    emergency_contact: z.array(z.number()),
    addresses: z.array(z.number()),
    gallery: z.array(z.number()),
    offer_letter: z.array(z.number()),
    employment_agreement: z.array(z.number()),
    handbook_acknowledgement: z.array(z.number()),
    vector_signatured: z.array(z.number()),
    business_card_template: z.array(z.number()),

    gusto: z.string().nullable(),
    harvest: nullableNumericMutationSchema(),
    zoom: nullableNumericMutationSchema(),
    freshdesk: nullableNumericMutationSchema(),

    commission_periods: z.array(commissionPeriodsMutationSchema).nullish(),

    /**
     * Financial Override PIN (revenue lockdown override PIN).
     * Optional; backend should not return this field in responses.
     */
    lockdown_override_pin: z.string().optional(),
  });

export type TeamMemberUpdateSchema = z.infer<typeof teamMemberUpdateSchema>;

export const teamMemberCreateSchema = teamMemberUpdateSchema.pick({
  first_name: true,
  last_name: true,
  gender: true,
  internal_extension: true,
  personal_email: true,
  work_email: true,
  job_title: true,
  hired_on: true,
  parent_id: true,
});

export type TeamMemberCreateSchema = z.infer<typeof teamMemberCreateSchema>;
